'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancelHoldButton = function (_BcReactComponent) {
  _inherits(CancelHoldButton, _BcReactComponent);

  function CancelHoldButton(props) {
    _classCallCheck(this, CancelHoldButton);

    var _this = _possibleConstructorReturn(this, (CancelHoldButton.__proto__ || Object.getPrototypeOf(CancelHoldButton)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(CancelHoldButton, [{
    key: 'handleClick',
    value: function handleClick() {
      this.props.cancelHold(this.props.metadataId);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _baseButtons.SecondaryButton,
        {
          handleClick: this.handleClick,
          block: true,
          className: 'cp-cancel-hold-button',
          'data-test-id': 'cancel-hold-' + this.props.metadataId,
          isLoading: this.props.isLoading },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'btn.cancelHold' })
      );
    }
  }]);

  return CancelHoldButton;
}(_baseBcReactComponent2.default);

CancelHoldButton.propTypes = {
  cancelHold: _react.PropTypes.func.isRequired,
  isLoading: _react.PropTypes.bool,
  metadataId: _react.PropTypes.string.isRequired
};

exports.default = CancelHoldButton;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/cancel-hold-button/lib/components/CancelHoldButton.component.js
// module id = 1395
// module chunks = 1